import React, { Component } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Avatar from "../../assets/components/Avatar/Avatar";
import "./MonCompte.css";

/**
 * Édition des données du COMPTE (patron) : nom, prénom, email, téléphone.
 * (L'édition d'un restaurant se fait sur la page Profil.)
 */
class MonCompte extends Component {
  constructor(props) {
    super(props);
    this.state = {
      compte: {},
      message: "",
      photoMessage: "",
    };
  }

  componentDidMount() {
    this.getCompte();
  }

  getCompte = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil", {
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      }),
    })
      .then((r) => r.json())
      .then((compte) => this.setState({ compte }))
      .catch(() => {});
  };

  handleInput = (e) => {
    const compte = { ...this.state.compte, [e.target.name]: e.target.value };
    this.setState({ compte });
  };

  uploadPhoto = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil/photo", {
      method: "PUT",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
      body: data,
    })
      .then((r) => r.json())
      .then((resp) => {
        if (resp.photo) {
          // Recharge pour que l'avatar se mette à jour partout (Mon compte + icône Navbar)
          window.location.reload();
        } else {
          this.setState({
            photoMessage: resp.message || "Échec de l'envoi de la photo.",
          });
        }
      })
      .catch(() => {});
  };

  deletePhoto = () => {
    if (!window.confirm("Supprimer votre photo de profil ?")) return;
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil/photo", {
      method: "DELETE",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
    })
      .then((r) => r.json())
      .then(() => {
        // Recharge pour mettre à jour l'avatar partout (Mon compte + icône Navbar)
        window.location.reload();
      })
      .catch(() => {});
  };

  save = () => {
    const data = {
      bossName: this.state.compte.bossName,
      bossFirstName: this.state.compte.bossFirstName,
      email: this.state.compte.email,
      phone: this.state.compte.phone,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil/edit", {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
      body: JSON.stringify(data),
    })
      .then((r) => r.json())
      .then((resp) => this.setState({ message: resp.message }))
      .catch(() => {});
  };

  render() {
    const c = this.state.compte;
    return (
      <Container className="monCompte">
        <Row>
          <Col md={{ span: 6, offset: 3 }} className="monCompteCol">
            <h1 className="title">Mon compte</h1>

            <div className="compteAvatarBlock">
              <Avatar
                photo={c.photo}
                firstName={c.bossFirstName}
                lastName={c.bossName}
                className="monCompteAvatar"
              />
              <form onSubmit={this.uploadPhoto} className="photoForm">
                <input type="file" name="file" accept="image/*" />
                <div className="photoButtons">
                  <Button type="submit" className="photoButton">
                    Mettre à jour la photo
                  </Button>
                  {c.photo ? (
                    <Button
                      type="button"
                      className="photoButton photoDeleteButton"
                      onClick={this.deletePhoto}>
                      Supprimer la photo
                    </Button>
                  ) : null}
                </div>
              </form>
              <p className="photoMessage">{this.state.photoMessage}</p>
            </div>

            <label>Nom</label>
            <input
              type="text"
              name="bossName"
              placeholder="Nom"
              value={c.bossName || ""}
              onChange={this.handleInput}
            />

            <label>Prénom</label>
            <input
              type="text"
              name="bossFirstName"
              placeholder="Prénom"
              value={c.bossFirstName || ""}
              onChange={this.handleInput}
            />

            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={c.email || ""}
              onChange={this.handleInput}
            />

            <label>Téléphone</label>
            <input
              type="text"
              name="phone"
              placeholder="Téléphone"
              value={c.phone || ""}
              onChange={this.handleInput}
            />

            <Button className="submitButton" onClick={this.save}>
              Enregistrer
            </Button>
            <p className="monCompteMessage">{this.state.message}</p>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MonCompte;
